 jQuery(document).ready(function () {
    if($('.collection-main-piercing .row').length>0){
        $('.collection-main-piercing .row').addClass('owl-carousel');
        $('.collection-main-piercing .row').owlCarousel({
            loop:false,
            margin:0,
            dots: false,
            nav: false,
            responsiveClass:true,
            responsive:{
                0:{
                    items:3
                },
                767:{
                    items:3
                },
                1000:{
                    items:4
                }
            }
        });
    }
    $(".mobile-facets__open-wrapper span").click(function () {
        $('.left-fillter details').attr("open", "open");
    });
    $(".menu-page .item a").click(function () {
        var data_id = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(data_id).offset().top - 80
        }, '5000');
     });
    var height_main = $(".main-collection-product").height();
    var height_footer1 = $("section.shopify-section-group-footer-group").height();
    var height_footer2 = $("div.shopify-section-group-footer-group").height();
    var height_filter = height_main + height_footer1 + height_footer2
    $('.mobile-facets__disclosure').click(function(){
        $('body.search').toggleClass('change');
        $('body.collection').toggleClass('change');
    });
    
    //listen for click event on li element
    $(document).on('click','.select__select-custom li',function(){
      $('.select__select-custom li').removeClass('selected')
      $(this).addClass('selected');
      //get index of clicked li element
      var selected_index = $(this).index();
      //set select element to selected option
      $('.mobile-facets__item--sortby li input').prop('checked', false);
       $('.mobile-facets__item--sortby li:eq(' + selected_index + ') label').addClass('visit')
      $('.mobile-facets__item--sortby li:eq(' + selected_index + ') label').trigger('click');
    });

   // video Youtube autoplay if hover
   VideoHover();
});
jQuery( window ).on("load", function() {  
   VideoHover();
});
function VideoHover() {
  $(".product-grid .grid__item .card-wrapper").on({
    mouseenter: function() {
      var $iframe = $(this).find('iframe');
      if ($iframe.length > 0) {
        var videoSrc = $iframe.attr('src');
        if (videoSrc) {
          if (videoSrc.indexOf('&autoplay=1') == -1) {
            $iframe.attr('src', videoSrc + '&autoplay=1&mute=1');
          }
        }
      }
    },
    mouseleave: function() {
      var $iframe = $(this).find('iframe');
      if ($iframe.length > 0) {
        var videoSrc = $iframe.attr('src');
        if (videoSrc) {
          if (videoSrc.indexOf('&autoplay=1') != -1) {
            $iframe.attr('src', videoSrc.replace('&autoplay=1&mute=1', ''));
          }
        }
      }
    }
  });
}

document.querySelectorAll('.mobile-facets__submenu.gradient').forEach(submenu => {
  submenu.addEventListener('click', function () {
    let childList = this.querySelector('.mobile-facets__list.list-unstyled');
    if (childList) {
      // Toggle display
      if (childList.style.display === "block") {
        childList.style.display = "none";
      } else {
        childList.style.display = "block";
      }
    }
  });
});